import { LEGACY_NARRATIVES, type LegacyReviewValues } from "./legacyReviewForm";

export function legacyReviewCapacityErrors(
  values: LegacyReviewValues
): Record<string, string> {
  const errors: Record<string, string> = {};
  LEGACY_NARRATIVES.forEach(({ field, label }) => {
    if (values[field].length > 200000)
      errors[field] = `${label} exceeds the 200,000-character draft limit.`;
  });
  if (values.additionalSections.length > 100)
    errors.additionalSections =
      "The draft exceeds the limit of 100 additional sections.";
  values.additionalSections.forEach((section, index) => {
    const limit = section.kind === "sourceTranscript" ? 5000000 : 200000;
    if (section.text.length > limit)
      errors[`additionalSections.${index}.text`] = `${
        section.label
      } exceeds the ${limit.toLocaleString("en-US")}-character draft limit.`;
  });
  return errors;
}
